<div id="unit-info">
    <h4 class="mb-4">Información de la unidad</h4>
    
    <p><span class="fw-bold">Nombre:</span> {{ name }}</p>
    
    <p><span class="fw-bold">Nº de lecciones:</span> {{ lessonsNum }}</p>
</div>